import { render, staticRenderFns } from "./WolihubAuditoria.vue?vue&type=template&id=4bbc56d8&scoped=true"
import script from "./WolihubAuditoria.vue?vue&type=script&lang=js"
export * from "./WolihubAuditoria.vue?vue&type=script&lang=js"
import style0 from "./WolihubAuditoria.vue?vue&type=style&index=0&id=4bbc56d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc56d8",
  null
  
)

export default component.exports